import { EventNameType, EventPropertiesType } from '@/utils/analyticsEventTypes';
import { trackEvent } from '@/lib/analyticsTrack';

export type TrackFn = <T extends EventNameType>(
  eventName: T,
  eventProperties: EventPropertiesType<T>
) => void;

/** Re-exported for non-hook call sites that import it from here (e.g. class
 *  error boundaries) — the single implementation lives in lib/analyticsTrack. */
export { trackEvent } from '@/lib/analyticsTrack';

/** Component-side analytics. Delegates to the shared trackEvent implementation
 *  (lib/analyticsTrack.ts) — one enrichment path for hooks and lib code alike.
 *  `track` is a stable module function, so it's safe in effect deps. */
export const useAnalytics = () => {
  return { track: trackEvent as TrackFn };
};
